export default "__VITE_ASSET__DXS5w_rR__"